import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import Landing from './pages/Landing'
import { CapsuleViewer } from './pages/CapsuleViewer'
import { CapsuleListPage } from './pages/admin/CapsuleListPage'
import { CurationTool } from './pages/admin/CurationTool'
import { SyncView } from './pages/admin/SyncView'
import { LibraryPage } from './pages/LibraryPage'
import { LoginPage } from './pages/LoginPage'
import { AuthVerifyPage } from './pages/AuthVerifyPage'
import { SubmissionHistoryPage } from './pages/SubmissionHistoryPage'
import { ReviewDashboard } from './pages/admin/ReviewDashboard'
import { CourseListPage } from './features/courses/pages/CourseListPage'
import { CourseDetailPage } from './features/courses/pages/CourseDetailPage'
import { CourseCapsuleViewer } from './features/courses/pages/CourseCapsuleViewer'
import { CourseAdminListPage } from './features/courses/pages/admin/CourseAdminListPage'
import { CourseCurationTool } from './features/courses/pages/admin/CourseCurationTool'

export default function App() {
  return (
    <AuthProvider>
      <div style={{ minHeight: '100vh', background: 'var(--color-bg)' }}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/capsule/:slug" element={<CapsuleViewer />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/submissions"
            element={
              <ProtectedRoute>
                <SubmissionHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route path="/auth/verify" element={<AuthVerifyPage />} />

          {/* Courses (public) */}
          <Route path="/courses" element={<CourseListPage />} />
          <Route path="/courses/:courseSlug" element={<CourseDetailPage />} />
          <Route path="/courses/:courseSlug/:capsuleSlug" element={<CourseCapsuleViewer />} />

          {/* Admin */}
          <Route
            path="/admin/capsules"
            element={
              <ProtectedRoute requireAdmin>
                <CapsuleListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/curate"
            element={
              <ProtectedRoute requireAdmin>
                <CurationTool />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/curate/sync"
            element={
              <ProtectedRoute requireAdmin>
                <SyncView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reviews"
            element={
              <ProtectedRoute requireAdmin>
                <ReviewDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/courses"
            element={
              <ProtectedRoute requireAdmin>
                <CourseAdminListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/courses/edit"
            element={
              <ProtectedRoute requireAdmin>
                <CourseCurationTool />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#fff' }}>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for doesn't exist.</p>
              <a href="/" style={{ color: '#3b82f6', marginTop: '1rem' }}>Go Home</a>
            </div>
          } />
        </Routes>
      </div>
    </AuthProvider>
  )
}
